import { forwardRef } from 'react';

import { Box, IconButton, Typography } from '@mui/material';
import { CloseIcon } from '@truvhq/ui';

type MobileDesktopBannerProps = {
  onDismiss?: () => void;
};

export const MobileDesktopBanner = forwardRef<HTMLDivElement, MobileDesktopBannerProps>(({ onDismiss }, ref) => {
  return (
    <Box
      ref={ref}
      className="relative z-10 flex items-center justify-center px-4 py-3"
      data-testid="mobile-desktop-banner"
      sx={{
        width: '100vw',
        maxWidth: '100vw',
        backgroundImage: 'linear-gradient(90deg, #224185 0%, #254a9e 15%, #203565 50%, #2855bb 70%, #223c79 100%)',
      }}
    >
      <Typography className="w-full text-center text-white" variant="body2">
        Truv dashboard works best on desktop.
        <br />
        Please use desktop for optimized experience.
      </Typography>
      <IconButton
        aria-label="close"
        data-testid="mobile-banner-dismiss"
        size="small"
        sx={{ position: 'absolute', right: 8, color: 'rgba(255,255,255,0.7)' }}
        onClick={onDismiss}
      >
        <CloseIcon />
      </IconButton>
    </Box>
  );
});

MobileDesktopBanner.displayName = 'MobileDesktopBanner';
